import { Action } from 'redux';

import { IncrementRouterSpaceReactKey } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';

export interface IncrementRouterSpaceReactKeyAction extends Action {}

export function incrementRouterSpaceReactKey(): IncrementRouterSpaceReactKeyAction {
  return {
    type: IncrementRouterSpaceReactKey
  };
}
export const isIncrementRouterSpaceReactKeyAction
  = isActionFactory<IncrementRouterSpaceReactKeyAction>(IncrementRouterSpaceReactKey);
